<script>
  export default {
    name: 'InputTag',

    props: {
      tags: {
        type: Array,
        default: () => [],
      },
      placeholder: {
        type: String,
        default: '',
      },
      onChange: {
        type: Function,
      },
      readOnly: {
        type: Boolean,
        default: false,
      },
      newTagOnComma: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        newTag: '',
      };
    },

    methods: {
      focusNewTag() {
        if (this.readOnly) { return; }
        this.$el.querySelector('.new-tag').focus();
      },
      addNew(tag) {
        if (tag && !this.tags.includes(tag)) {
          this.tags.push(tag);
          this.tagChange();
        }
        this.newTag = '';
      },
      remove(index) {
        this.tags.splice(index, 1);
        this.tagChange();
      },
      removeLastTag() {
        if (this.newTag) { return; }
        this.tagChange();
        this.tags.pop();
      },
      getPlaceholder() {
        if (!this.tags.length) {
          return this.placeholder;
        }
        return '';
      },
      tagChange() {
        if (this.onChange) {
          // avoid passing the observer
          this.onChange(JSON.parse(JSON.stringify(this.tags)));
        }
      },
    },
  };
</script>

<template>

  <div @click="focusNewTag()" v-bind:class="{'read-only': readOnly}" class="vue-input-tag-wrapper">
    <span v-for="(tag, index) in tags" class="label label-primary">
      <span>{{ tag }} <a v-if="!readOnly" @click.prevent.stop="remove(index)" class="remove"></a></span>
      <a v-if="!readOnly" @click.prevent.stop="remove(index)" class="remove">x</a>
    </span>

    <input v-if="!newTagOnComma" v-bind:placeholder="getPlaceholder()" type="text" v-model="newTag" v-on:keydown.delete.stop="removeLastTag()" v-on:keydown.enter.prevent.stop="addNew(newTag)" v-on:keydown.tab.prevent.stop="addNew(newTag)" class="new-tag"/>

    <input v-if="newTagOnComma" v-bind:placeholder="getPlaceholder()" type="text" v-model="newTag" v-on:keydown.delete.stop="removeLastTag()" v-on:keydown.enter.prevent.stop="addNew(newTag)" v-on:keydown.tab.prevent.stop="addNew(newTag)" class="new-tag"/>


  </div>

</template>

<style>

  .vue-input-tag-wrapper {
    background-color: #fff;
    border: 1px solid #ccc;
    overflow: hidden;
    padding-left: 4px;
    padding-top: 5px;
    cursor: text;
    text-align: left;
	border-radius: 4px;
	padding-bottom: 7px;
  }

  .vue-input-tag-wrapper .label {
    background-color: #3097D1;
    border-radius: 2px;
    border: 1px solid #3097D1;
    color: #fff;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    padding: 3px;
  }

  .vue-input-tag-wrapper .label .remove {
    cursor: pointer;
    font-weight: bold;
    color: #fff;
  }

  .vue-input-tag-wrapper .label .remove:hover {
    text-decoration: none;
  }

  .vue-input-tag-wrapper .label.remove::before {
    content: " x";
  }

  .vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: 0;
    color: #495056;
    font-size: 13px;
    font-weight: 400;
    /*margin-bottom: 6px;*/
    margin-top: 1px;
    outline: none;
    padding: 4px;
    padding-left: 0;
    width: auto;
  }

  .vue-input-tag-wrapper.read-only {
    cursor: default;
  }

  .label {
      margin-left: 6px;
      margin-right: 6px;
  }

</style>
